import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios'
import history from '../@f_routeshere/history'
import serviceUrlFile from '../../baseUrl.txt'
import utils from '../utils'

let resetStore: () => void

// Added this to avoid the circular dependencies issues between services and redux store
export const injectResetStoreAction = (fn: () => void) => {
  resetStore = fn
}

/* eslint no-underscore-dangle: 0 */

class HttpClient {
  private _instance: AxiosInstance

  private baseUrl!: string

  constructor() {
    this._instance = axios.create()
    this.setBaseUrl()
    this.initializeRequestInterceptor()
    this.initializeResponseInterceptor()
  }

  public get instance() {
    return this._instance
  }

  private static fetchBaseUrl(): Promise<string> {
    return fetch(serviceUrlFile)
      .then(res => res.text())
      .catch(err => {
        // eslint-disable-next-line
        console.error(err)
        return ''
      })
  }

  public setBaseUrl() {
    return HttpClient.fetchBaseUrl().then(url => {
      this._instance.defaults.baseURL = url
      this.baseUrl = url
    })
  }

  private initializeRequestInterceptor() {
    // eslint-disable-next-line
    const _this = this
    this._instance.interceptors.request.use(function (
      config: AxiosRequestConfig,
    ): Promise<AxiosRequestConfig> {
      const orderGUID = utils.getParamsFromURL('orderGUID')
      const token = utils.getTokenBasedOnOrderGUID(orderGUID)
      config.headers.Authorization = token ? `Bearer ${token}` : ''
      if (!config.baseURL) {
        if (!_this.baseUrl) {
          return _this.setBaseUrl().then(() => {
            config.baseURL = _this.baseUrl
            return Promise.resolve(config)
          })
        }
        config.baseURL = _this.baseUrl
      }
      return Promise.resolve(config)
    })
  }

  private initializeResponseInterceptor() {
    const responseHandler = (response: AxiosResponse) => response

    const errorHandler = (error: AxiosError | Error) => {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          if (error.response.status === 401) {
            const orderGUID = utils.getParamsFromURL('orderGUID')
            utils.removeTokenFromStorage(orderGUID)
            if (!window.location.href.includes('/login')) {
              resetStore()
              history.push(`/login?orderGUID=${orderGUID}`)
            }
          }
        }
      }
      return Promise.reject(error)
    }
    this._instance.interceptors.response.use(responseHandler, errorHandler)
  }
}

const httpClient = new HttpClient()

export default httpClient
